BaseModel = require('base/model')

class DynamicInsertionModel extends BaseModel
  defaults:
    accountId: null
    host: null

module.exports = DynamicInsertionModel
